import { handleActions } from 'redux-actions';
import { otpCodeVerifyError } from './action';
import { FormValues } from './view';

interface State {
  errors: Partial<FormValues>;
}

const initialState: State = {
  errors: {},
};

const reducer = handleActions(
  {
    [String(otpCodeVerifyError)]: (state, { payload }) => {
      return { ...state, errors: payload.errors };
    },
  },
  initialState,
);

export default reducer;
